import { render, staticRenderFns } from "./PublishingCompaniesEditPanelDialog.vue?vue&type=template&id=a912df66&scoped=true"
import script from "./PublishingCompaniesEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./PublishingCompaniesEditPanelDialog.vue?vue&type=script&lang=js"
import style0 from "./PublishingCompaniesEditPanelDialog.vue?vue&type=style&index=0&id=a912df66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a912df66",
  null
  
)

export default component.exports